export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_04-7c48db2ac1df72d88e70eac9e1058821.jpg";